import { useEffect, useRef } from 'react';

/**
 * Starts a loose-material order on its first line.
 *
 * A draft holds no position of its own: whether it becomes a container order or a loose-material
 * one is the wizard's decision, and reaching the positions step is what makes it the latter. The
 * line is asked for once per mount, because the draft still reads empty for a render or two while
 * the server mints it.
 */
// @ai-generated 2026-09-25T09:46:15+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function useFirstPosition(positionCount: number, canEdit: boolean, addPosition: () => Promise<unknown>): void {
    const asked = useRef(false);

    useEffect(() => {
        if (asked.current || !canEdit || positionCount > 0) {
            return;
        }

        asked.current = true;
        void addPosition();
    }, [positionCount, canEdit, addPosition]);
}
